import { MatrixClient } from 'matrix-js-sdk/src/matrix';

import { CustomMeedioMatrixEvents } from 'utils/matrixUtils';

export type LandingSection = 'messenger' | 'calls' | 'calendar';

export const USER_SETTINGS_ACCOUNT_DATA_KEY = CustomMeedioMatrixEvents.USER_SETTINGS;

interface UserSettingsContent {
  defaultLandingPage?: LandingSection;
  [key: string]: unknown;
}

export const setDefaultLandingPage = (matrixClient: MatrixClient, section: LandingSection): Promise<unknown> => {
  const existing = matrixClient.getAccountData(USER_SETTINGS_ACCOUNT_DATA_KEY as never);
  const existingContent = (existing?.getContent<UserSettingsContent>() ?? {}) as UserSettingsContent;
  const merged: UserSettingsContent = { ...existingContent, defaultLandingPage: section };
  return matrixClient.setAccountData(USER_SETTINGS_ACCOUNT_DATA_KEY as never, merged as never);
};
